import { render, staticRenderFns } from "./configReadText.vue?vue&type=template&id=170b8140&"
import script from "./configReadText.vue?vue&type=script&lang=js&"
export * from "./configReadText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports